import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {graphql} from 'react-apollo'
import {AvForm, AvField} from 'availity-reactstrap-validation'
import {Button, CardBody, Col, Row, Alert} from 'reactstrap'
import {createOrUpdateUsersMutation} from './mutations'
// import {withGaTracker, withGaEvent} from '../Support/GoogleAnalytics'

class UserForm extends Component {

  constructor(props) {
    super(props)
    this.state = {
      validation_errors: null,
      success_message: null,
      showPassword: false,
      showPasswordConfirmation: false,
      generatedPassword: ''
    }

    this.submitFunction = this.submitFunction.bind(this)
    this.generatePassword = this.generatePassword.bind(this)
  }

  static propTypes = {
    person_id: PropTypes.number.isRequired,
    editData: PropTypes.object,
    mutate: PropTypes.func.isRequired,
    formToggleFunction: PropTypes.func,
    clearFunction: PropTypes.func
  }

  componentDidMount() {
    // withGaTracker(window.location.pathname + '/user_form') // GA TRACKER
  }

  componentWillUnmount() {
    this.props.clearFunction && this.props.clearFunction()
  }

  generatePassword() {
    const lower = 'abcdefghijklmnopqrstuvwxyz'
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const digits = '0123456789'
    const special = '!@#$%^&*()_+-=[]{}'
    const all = lower + upper + digits + special
    const rand = chars => chars[Math.floor(Math.random() * chars.length)]
    const password = [
      rand(lower), rand(upper), rand(digits), rand(special),
      ...Array.from({length: 8}, () => rand(all))
    ].sort(() => Math.random() - 0.5).join('')
    this.setState({generatedPassword: password, showPassword: true, showPasswordConfirmation: true})
  }

  submitFunction(e, values) {
    this.props.mutate({
      variables: {
        id: this.props.editData ? this.props.editData.id : null,
        ...values,
        person_id: this.props.person_id
      }
    })
      .then(({data}) => {
        if (data.createOrUpdateUser.errors) {
          // withGaEvent({category: 'User', action: 'error save'}) // GA EVENT
          this.setState({validation_errors: data.createOrUpdateUser.errors})
        } else {
          // withGaEvent({category: 'User', action: 'save'}) // GA EVENT
          this.setState({validation_errors: null, success_message: 'Dane zostały zapisane'})
          setTimeout(() => this.setState({success_message: null}), 3000)
          this.props.formToggleFunction && this.props.formToggleFunction()
        }
      })
  }

  render() {
    return (
      <CardBody>
        <Alert color="success" isOpen={!!this.state.success_message} toggle={() => this.setState({success_message: null})}>
          {this.state.success_message}
        </Alert>
        {this.state.validation_errors &&
        <h4 className="errors-heading">{this.state.validation_errors.join(', ')}</h4>
        }
        <AvForm id="user-form" onValidSubmit={this.submitFunction} className="FormClassLabel">
          <Row>
            <Col xs="12" sm="4">
              <AvField
                id="user-email-form"
                name="email"
                label="Email"
                type="email"
                value={this.props.editData.email || ''}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col xs="12" sm="4">
              <div style={{position: 'relative'}}>
                <AvField id="user-password-form"
                  name="password"
                  label="Password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  value={this.state.generatedPassword}
                  validate={{
                    required: {value: true, errorMessage: 'Hasło jest wymagane'},
                    minLength: {value: 8, errorMessage: 'Hasło musi mieć co najmniej 8 znaków'},
                    pattern: {
                      value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d]).{8,}$/,
                      errorMessage: 'Hasło musi zawierać małą literę, dużą literę, cyfrę i znak specjalny'
                    }
                  }}
                />
                <i
                  className={`fa ${this.state.showPassword ? 'fa-eye-slash' : 'fa-eye'}`}
                  onClick={() => this.setState(s => ({showPassword: !s.showPassword}))}
                  style={{position: 'absolute', right: 10, top: 34, cursor: 'pointer'}}
                />
              </div>
            </Col>
            <Col xs="12" sm="4">
              <div style={{position: 'relative'}}>
                <AvField id="user-password-confirmation-form"
                  name="password_confirmation"
                  label="Password confirmation"
                  type={this.state.showPasswordConfirmation ? 'text' : 'password'}
                  value={this.state.generatedPassword}
                  validate={{
                    required: {value: true, errorMessage: 'Potwierdzenie hasła jest wymagane'},
                    match: {value: 'password', errorMessage: 'Hasła muszą być identyczne'}
                  }}
                />
                <i
                  className={`fa ${this.state.showPasswordConfirmation ? 'fa-eye-slash' : 'fa-eye'}`}
                  onClick={() => this.setState(s => ({showPasswordConfirmation: !s.showPasswordConfirmation}))}
                  style={{position: 'absolute', right: 10, top: 34, cursor: 'pointer'}}
                />
              </div>
            </Col>
          </Row>
          <br/>
          <Button id="user-generate-password-btn" type="button" color="secondary" onClick={this.generatePassword}>
            <i className="fa fa-key"/> Generate password
          </Button>
          {' '}
          <Button id="user-copy-password-btn" type="button" color="info" disabled={!this.state.generatedPassword}
            onClick={() => navigator.clipboard.writeText(this.state.generatedPassword)}>
            <i className="fa fa-copy"/> Copy password
          </Button>
          <br/> <br/>
          {this.props.formToggleFunction && <Button id="user-close-form-btn" color="danger" className="float-right"
            onClick={this.props.formToggleFunction}>
            <i className="fa fa-close"/> Close
          </Button>}
          <Button id="user-save-form-btn" type="submit" color="primary" className="float-right">
            <i className="fa fa-plus"/> Save
          </Button>
          <br/> <br/>
        </AvForm>
      </CardBody>
    )
  }
}

const UserFormWithMutation = graphql(createOrUpdateUsersMutation)(UserForm)

export default UserFormWithMutation



// WEBPACK FOOTER //
// ./src/components/People/UserForm.js